import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import { AxiosError } from 'axios'

import { isDenebEnabled } from '@/const/flags'
import { aspidaClient } from '@/lib/aspida'
import { queryClient } from '@/lib/react-query'
import { useProxyStore } from '@/providers/proxyStore/ProxyStoreContext'

import { cartKeyFactory } from './key'

type DeleteCartItemDTO = {
  itemCode: string
}

type MutationResponse = Awaited<ReturnType<typeof aspidaClient.v1.cart.$delete>>

type UseDeleteCartItemOptions = {
  config?: Omit<
    UseMutationOptions<MutationResponse, AxiosError, DeleteCartItemDTO>,
    'mutationFn'
  >
}

export const useDeleteCartItem = ({ config }: UseDeleteCartItemOptions) => {
  const { storeCode } = useProxyStore()

  const mutationFn = ({ itemCode }: DeleteCartItemDTO) => {
    if (isDenebEnabled && storeCode) {
      return aspidaClient.v1.employee.proxy_stores
        ._storeCode(storeCode)
        .cart.items._itemCode(itemCode)
        .$delete()
    }
    return aspidaClient.v1.cart.items._itemCode(itemCode).$delete()
  }

  return useMutation({
    mutationFn,
    onSuccess: () => queryClient.invalidateQueries(cartKeyFactory.all),
    ...config,
  } as UseMutationOptions<MutationResponse, AxiosError, DeleteCartItemDTO>)
}
